import { createContext } from 'react';
import { noop } from '@vkontakte/vkjs';
import { ShowSelectPopout, ShowAlert, ShowConfirm, ShowCustomPopout, WithScreenSpinner } from './types';

export interface PopoutContext {
  /**
   * Показывает Alert для подтверждения действия перед выпонением коллбека
   */
  showAlert: ShowAlert;
  /**
   * Показывает Alert для подтверждения действия перед выпонением коллбека
   */
  showConfirm: ShowConfirm;
  /**
   * Показывает компонент ActionSheet
   */
  showSelectPopout: ShowSelectPopout;
  /**
   * Оборачивает промис, позволяет рисовать ScreenSpinner
   * на время выполнения промиса
   */
  withScreenSpinner: WithScreenSpinner;
  /**
   * Показывает переданный попаут
   */
  showCustomPopout: ShowCustomPopout;
  /**
   * Закрывает все попауты
   */
  closePopouts: VoidFunction;
}

export interface PopoutStateContext {
  /**
   * Открыт ли попаут
   */
  popoutOpened: boolean;
}

export const popoutContext = createContext<PopoutContext>({
  showAlert: noop,
  showConfirm: noop,
  showSelectPopout: noop,
  withScreenSpinner: (promise) => promise,
  showCustomPopout: noop,
  closePopouts: noop,
});

export const popoutStateContext = createContext<PopoutStateContext>({
  popoutOpened: false,
});
